import React from 'react';
import { Dialog, Grid, Typography, Stack } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import {
  CustomButton,
  CustomDialogAction,
  CustomDialogContent,
  CustomDialogTitle,
  CustomInputLabel,
  CustomTextField,
  InputProps,
  StyledCard,
} from '../../../../../../../custom/components';
import { CloseIconBtn, } from 'custom/constants';

const CronModal = (props) => {
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props?.modal=='cron'} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Set Recheck Interval
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form onSubmit={props.saveCronInterval} onReset={props.onClose} className={styles.w100}>
          <CustomDialogContent>

            <Typography variant='body2' color='primary' mb={2} borderBottom={'1px solid #e8e8e8'}>
              Set the interval for automatic customs status retrieval.
            </Typography>
            <Stack direction='column' spacing={2}>
              <StyledCard>
                <Grid container spacing={2} className={styles.formGrid}>
                  <Grid item xs={12} sm={12}>
                    <CustomInputLabel htmlFor='cron' required>Recheck Interval (in hours)</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron'
                      placeholder='Enter Interval'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron'
                      value={props.cron}
                      error={Boolean(props.cronErrors?.cron)}
                      helperText={props.cronErrors?.cron}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <CustomInputLabel htmlFor='cron_period' required>Customs Status Retrieval Period (in days)</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_period'
                      placeholder='Enter Period'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_period'
                      value={props.cron_period}
                      error={Boolean(props.cronErrors?.cron_period)}
                      helperText={props.cronErrors?.cron_period}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <CustomInputLabel htmlFor='cron_code' required>Customs Status Code to mark as cleared</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_code'
                      placeholder='Enter Customs Status Code'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_code'
                      value={props.cron_code}
                      error={Boolean(props.cronErrors?.cron_code)}
                      helperText={props.cronErrors?.cron_code}
                    />
                  </Grid>
                </Grid>
              </StyledCard>
              <StyledCard>
                <Grid container spacing={2} className={styles.formGrid}>
                  <Grid item xs={12} sm={12} order={4}>
                    <CustomInputLabel htmlFor='cron_spl' required>Fetch Customs Status after clearance based on customs SPL code</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_spl'
                      placeholder='Enter SPL Codes'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_spl'
                      value={props.cron_spl}
                      error={Boolean(props.cronErrors?.cron_spl)}
                      helperText={props.cronErrors?.cron_spl}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} order={2}>
                    <CustomInputLabel htmlFor='cron_spl_period' required>Fetch Customs Status after clearance based on SPL code period (in days)</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_spl_period'
                      placeholder='Enter Period'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_spl_period'
                      value={props.cron_spl_period}
                      error={Boolean(props.cronErrors?.cron_spl_period)}
                      helperText={props.cronErrors?.cron_spl_period}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} order={1}>
                    <CustomInputLabel htmlFor='cron_spl_interval' required>Fetch Customs Status after clearance based on customs SPL code interval (in hours)</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_spl_interval'
                      placeholder='Enter Interval'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_spl_interval'
                      value={props.cron_spl_interval}
                      error={Boolean(props.cronErrors?.cron_spl_interval)}
                      helperText={props.cronErrors?.cron_spl_interval}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} order={3}>
                    <CustomInputLabel htmlFor='cron_spl_code' required>Customs Status Code to mark as cleared after clearance</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      autoFocus
                      id='cron_spl_code'
                      placeholder='Enter Customs Status Code'
                      type='text'
                      onChange={props.onChangeCron}
                      name='cron_spl_code'
                      value={props.cron_spl_code}
                      error={Boolean(props.cronErrors?.cron_spl_code)}
                      helperText={props.cronErrors?.cron_spl_code}
                    />
                  </Grid>
                </Grid>
              </StyledCard>
            </Stack>
          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset'> Close</CustomButton>
            <CustomButton variant='contained' type='submit'>{'Update'}</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default CronModal;